import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Phone, Globe, ArrowRight } from 'lucide-react';
interface AgencyPopupProps {
  isOpen: boolean;
  onClose: () => void;
}
export function AgencyPopup({
  isOpen,
  onClose
}: AgencyPopupProps) {
  return <AnimatePresence data-id="element-6">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 bg-black/20 backdrop-blur-sm" data-id="element-7" />
          <motion.div initial={{
        opacity: 0,
        y: 100,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed bottom-4 left-4 right-4 md:bottom-8 md:left-auto md:right-8 z-50 w-auto md:w-[400px] glass-effect rounded-2xl p-6 md:p-8" data-id="element-8">
            <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-900 transition-colors" data-id="element-9">
              <X size={20} data-id="element-10" />
            </button>

            <div className="mb-6" data-id="element-11">
              <div className="w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center mb-4" data-id="element-12">
                <Globe size={24} data-id="element-13" />
              </div>
              <h3 className="text-xl font-semibold mb-3 leading-tight" data-id="element-14">
                Сподобався цей дизайн?
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-15">
                Цей сайт ми можемо зробити для вас повністю під ключ, адаптувати
                під усі ваші потреби.
                <span className="block mt-2 font-semibold text-gray-900" data-id="element-16">
                  Вартість сайту під ключ — лише 8 000 грн.
                </span>
              </p>
            </div>

            <div className="space-y-3" data-id="element-17">
              <a href="tel:+380508399309" className="flex items-center justify-between w-full p-3 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors group" data-id="element-18">
                <div className="flex items-center gap-3" data-id="element-19">
                  <Phone size={18} className="text-gray-500 group-hover:text-gray-900 transition-colors" data-id="element-20" />
                  <span className="font-medium text-sm" data-id="element-21">+38 050 839 93 09</span>
                </div>
                <ArrowRight size={16} className="text-gray-400 group-hover:text-gray-900 transition-colors" data-id="element-22" />
              </a>

              <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between w-full p-3 rounded-xl bg-gray-900 text-white hover:bg-gray-800 transition-colors group" data-id="element-23">
                <div className="flex items-center gap-3" data-id="element-24">
                  <Globe size={18} className="text-gray-400 group-hover:text-white transition-colors" data-id="element-25" />
                  <span className="font-medium text-sm" data-id="element-26">jetly.agency/ua</span>
                </div>
                <ArrowRight size={16} className="text-gray-400 group-hover:text-white transition-colors" data-id="element-27" />
              </a>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}